import { motion } from 'framer-motion';

export const YouTubeVideo = ({ 
  videoId = "wOXzHWtbhqM",
  title = "ASA Video"
}) => {
  return (
    <motion.div 
      data-testid="youtube-embed"
      className="relative w-full aspect-video rounded-2xl overflow-hidden border border-white/10 shadow-[0_0_40px_rgba(0,163,255,0.1)] bg-black"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <iframe
        src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute top-0 left-0 w-full h-full border-none"
      />
    </motion.div>
  );
};

export default YouTubeVideo;
